import Vue from "vue";
import moment from 'moment'
import {truncate} from "lodash";

Vue.filter("formatMoney", val => {
  let minus = false;
  if (val) {
    if (Math.sign(val) === -1) {
      minus = true;
      val = -val;
    }
    val = val
      .toString()
      .split(",")
      .join("");
    let output = "";
    while (val.length >= 3) {
      const last3Digits = val.slice(val.length - 3, val.length);
      val = val.slice(0, val.length - 3);
      output = "," + last3Digits + output;
    }
    if (val.length === 0) {
      output = output.slice(1, output.length);
    } else {
      output = val + output;
    }
    return (minus ? "-" + output : output) + " đ";
  } else return "0 đ";
});

Vue.filter("formatMoneyNotUnit", val => {
  let minus = false;
  if (val) {
    if (Math.sign(val) === -1) {
      minus = true;
      val = -val;
    }
    val = val
      .toString()
      .split(",")
      .join("");
    let output = "";
    while (val.length >= 3) {
      const last3Digits = val.slice(val.length - 3, val.length);
      val = val.slice(0, val.length - 3);
      output = "." + last3Digits + output;
    }
    if (val.length === 0) {
      output = output.slice(1, output.length);
    } else {
      output = val + output;
    }
    return (minus ? "-" + output : output) + "";
  } else return "0";
});

Vue.filter("truncateWord", (text,length) => {
  const l = length || 60
  return truncate(text,{length : l})
});

Vue.filter('formatDateTime', date => {
    if (!date) return
    return moment(date).format('DD/MM/YYYY - HH:mm')
})
